import { IRootState } from '../../../store'
import { IInitialAssessmentState } from '../store/initialAssessment.types'

export const getInitialAssessmentSelector = (state: IRootState): IInitialAssessmentState => state.initialAssessment
